import { Timestamp } from 'google-protobuf/google/protobuf/timestamp_pb';
import {
  AttributeCondition,
  Value,
  ListOfValues,
} from '@pushwoosh/rpc-service-client/pushwoosh/events/events_pb';
import Operator = AttributeCondition.Operator;
import { type ConditionValue } from '../../types';
import { isMultiOperator } from '../segments/helpers';

type ValueTypeConfig = {
  method: string;
  tagType: string;
  convertToDb?: (a: any) => any;
};
export const valuesTypes: ValueTypeConfig[] = [
  {
    method: 'Integer',
    tagType: 'integer',
  },
  {
    method: 'String',
    tagType: 'string',
  },
  {
    method: 'Bool',
    tagType: 'boolean',
  },
  {
    method: 'List',
    tagType: 'list',
  },
  {
    method: 'Timestamp',
    tagType: 'date',
    convertToDb: (d: Date): Timestamp => {
      const t = new Timestamp();
      t.fromDate(d);
      return t;
    },
  },
  {
    method: 'Float',
    tagType: 'decimal',
  },
];

const operatorsMap: Record<string, Operator> = {
  eq: Operator.EQ,
  noteq: Operator.NOT_EQ,
  lte: Operator.LTE,
  gte: Operator.GTE,
  between: Operator.BETWEEN,
  in: Operator.IN,
  notin: Operator.NOT_IN,
};

export function toAttributeCondition(
  condition: ConditionValue,
): AttributeCondition {
  const ac = new AttributeCondition();
  ac.setName(condition.name);
  ac.setOperator(operatorsMap[condition.operator]);
  if (condition.operator === 'between') {
    const met = `set${
      valuesTypes.find((vtc) => vtc.tagType === condition.type)!.method
    }`;
    ac.setValuesList([
      (new Value() as any)[met](condition.values[0]),
      (new Value() as any)[met](condition.values[1]),
    ]);
  } else {
    const value = new Value();
    if (isMultiOperator(condition.operator)) {
      value.setList(new ListOfValues().setValuesList(condition.values));
    } else {
      const met = `set${
        valuesTypes.find((vtc) => vtc.tagType === condition.type)!.method
      }`;
      (value as any)[met](condition.values[0]);
    }
    ac.setValuesList([value]);
  }
  return ac;
}
